angular.module('zc.commonApi')

.factory 'ProjectParticularEvent', ($resource, $q, BaseProjectCrudService) ->
  class ProjectParticularEvent extends BaseProjectCrudService

  new ProjectParticularEvent(
    $resource
    $q
    '/api/projects/:projectId/particular_events/:id'
    'particular_event'
    'particular_events'
  )




// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/particular_event.service.coffee